export const contentSpecialtyMap = {
	'test-group': 1,
	'acupuncture-and-oriental-medicine': 1,
	chiropractic: 2,
	naturopathy: 3,
	'dietetic-and-nutrition-services': 4,
	podiatry: 5,
	RehabilitativeServicesBothDistinctions: 6,
	RehabilitativeServicesMetro: 7,
	RehabilitativeServicesRural: 8,
	'massage-therapy': 9,
	'physical-occupational-and-speech-therapy-and-athletic-training': 10,
};

export const mapAndTransformSpecialtyString = specialtyString => {
	const specialtyType = specialtyString
		.split('-')
		.map(word => {
			if (word.toLowerCase() === 'and') {
				return 'and';
			}
			return word.charAt(0).toUpperCase() + word.slice(1);
		})
		.join(' ');

	const mappedValue = contentSpecialtyMap[specialtyString];

	return {
		transformedString: specialtyType,
		mappedValue,
	};
};
